// libs
import React, { memo } from 'react';

// global components
import SubNav, { SUB_NAV_PLACEMENT } from 'shared/components/SubNav';

// components
import SubMenu from './components/SubMenu';

// constants
import { TEXTS } from './constants';
import { TAB_INDEX } from 'shared/constants';

// styles
import { AuthContainer, TextContainer, IconWrapper } from './styles';

// icon
import { useStoreIcon, IconName } from 'shared/icons';
import { useDomainConfig } from 'shared/domainConfig/context/context';
import { useDwebSavedPaymentsContext } from 'shared/components/DwebSavedPayments/context';
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

const ACCOUNT_ICON_SIZE = '24px';

function Auth() {
  const AccountMoreIcon = useStoreIcon(IconName.ACCOUNT);
  const { HEADER_ICON_LAYOUT } = useDomainConfig();
  const isColumn = HEADER_ICON_LAYOUT === 'column';
  const { showSavedPayments } = useDwebSavedPaymentsContext();
  const { dweb: isSavedPaymentsEnabledOnDweb = false } = useRemoteConfig('savePaymentMethod');

  return (
    <SubNav
      subMenu={
        <SubMenu
          onOpenSavedPayments={
            isSavedPaymentsEnabledOnDweb ? showSavedPayments : undefined
          }
        />
      }
      placement={SUB_NAV_PLACEMENT.RIGHT}
    >
      <AuthContainer isColumn={isColumn} data-at="my_account_popup_dweb">
        <IconWrapper
          isColumn={isColumn}
          tabIndex={TAB_INDEX.ACTION_INVISIBILITY}
          className="megamenu-svg"
        >
          <AccountMoreIcon size={ACCOUNT_ICON_SIZE} />
        </IconWrapper>
        <TextContainer>{TEXTS.ACCOUNT}</TextContainer>
      </AuthContainer>
    </SubNav>
  );
}

export default memo(Auth);
